import Close from '@mui/icons-material/Close';
import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SignatureContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column' as const,
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
  },
  backgroundColor: theme.palette.background.paper,
}));

export const SignaturePadArea = styled(Stack)(({ theme }) => ({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.neutral,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
}));

export const SignaturePadWrapper = styled(Box)({
  width: '100%',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  position: 'relative' as const,
});

export const SignatureCanvas = styled('canvas')({
  position: 'absolute' as const,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
});

export const SignatureMarker = styled(Close)({
  position: 'absolute' as const,
  left: 24,
  bottom: 0,
  pointerEvents: 'none' as const,
});

export const SignatureLine = styled(Box)(({ theme }) => ({
  position: 'absolute' as const,
  left: 48,
  right: 24,
  bottom: 0,
  borderBottom: `1px solid ${theme.palette.grey[500]}`,
  pointerEvents: 'none' as const,
}));
